const mixin = {
  data() {
    return {
      Model: {
        productName: null,
        productType: null,
        productRecordCode: null,
        productFoundingDate: null,
        productRecordDate: null,
        productRecordNo: null,
        productSurvivalPeriod: null,
        productScale: null,
        productManager: null,
        productDeposit: null,
      },
      options: {
        scrollToInvalidField: false,
      },
      Fields: [
        {
          type: 'input',
          modelKey: 'productName',
          label: '产品名称',
          props: {
            type: 'text',
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'productType',
          label: '产品类型',
          props: {
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'productFoundingDate',
          label: '成立时间',
          props: {
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'productRecordCode',
          label: '备案机构',
          props: {
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'productRecordDate',
          label: '备案时间',
          props: {
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'productRecordNo',
          label: '备案编号',
          props: {
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'productSurvivalPeriod',
          label: '存续期(年)',
          props: {
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'productScale',
          label: '规模(万)',
          props: {
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'productManager',
          label: '管理人',
          props: {
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
        {
          type: 'input',
          modelKey: 'productDeposit',
          label: '托管人',
          props: {
            readonly: true,
          },
          rules: {
            required: false,
          },
        },
      ],
    };
  },
};
export default mixin;
